"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AFFILIATE_PROGRAM_EVENTS = void 0;
exports.AFFILIATE_PROGRAM_EVENTS = {
    ITEM_SOLD: 'ITEM_SOLD',
    ITEM_SOLD_BY_REFERRER: 'ITEM_SOLD_BY_REFERRER',
    ITEM_REFUNDED: 'ITEM_REFUNDED',
    ITEM_REPLACED: 'ITEM_REPLACED',
    REFERRAL_REWARD: 'REFERRAL_REWARD',
    PAYOUT_SENT: 'PAYOUT_SENT'
};
//# sourceMappingURL=affiliateProgramEvents.js.map